import React, { useEffect, useRef, useState } from "react";
import { usePmsTheme } from "../../Components/PmsThemeContext";
import { FiDownload, FiUpload } from "react-icons/fi";
import CorporateCatalogImport from "./CorporateCatalogImport";
import { CATALOG_IMPORT_TYPES, downloadCatalogTemplate } from "./corporateCatalogWorkbook";

export default function CorporateCatalogImportActions({ kind, catalog, measurementUnits, disabled, onImported }) {
  const { languageId } = usePmsTheme();
  const [open, setOpen] = useState(false), [notice, setNotice] = useState("");
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const type = CATALOG_IMPORT_TYPES[kind];
  if (!type) return null;
  return <>
    <button className="cp-button" disabled={disabled} onClick={() => downloadCatalogTemplate(kind, catalog, measurementUnits, languageId)}><FiDownload />Download template</button>
    <button className="cp-button cp-import-launch" disabled={disabled} onClick={() => { setNotice(""); setOpen(true); }}><FiUpload />Import Excel</button>
    {notice && <span className="cp-muted" role="status">{notice}</span>}
    {open && <CorporateCatalogImport kind={kind} catalog={catalog} measurementUnits={measurementUnits} onClose={() => setOpen(false)} onImported={async (result) => {
      if (!mounted.current) return;
      setOpen(false); setNotice(`${result.summary.create} ${type.label} imported.`);
      await onImported(result);
    }} />}
  </>;
}
